/* src/app/private/configrations/configuration-panel/configuration-panel.component.scss */
.configuration-panel-container {
  padding: 1.5rem;
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}
.configuration-panel-container .card {
  background: white;
  border-radius: 8px;
  padding: 2rem;
}
.configuration-panel-container .info-note {
  animation: fadeIn 0.3s ease-in;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.configuration-panel-container .domain-email-section .field label,
.configuration-panel-container .module-assignment-section .field label,
.configuration-panel-container .communication-config-content .field label,
.configuration-panel-container .whatsapp-config-content .field label {
  color: #495057;
  font-weight: 500;
}
.configuration-panel-container .domain-email-section .field .text-red-500,
.configuration-panel-container .module-assignment-section .field .text-red-500,
.configuration-panel-container .communication-config-content .field .text-red-500,
.configuration-panel-container .whatsapp-config-content .field .text-red-500 {
  color: #ef4444;
}
.configuration-panel-container .no-domain-section {
  padding: 3rem 1rem;
}
.configuration-panel-container .email-list-table {
  margin-top: 2rem;
}
.configuration-panel-container .email-list-table ::ng-deep .p-datatable {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
}
.configuration-panel-container .email-list-table ::ng-deep .p-datatable .p-datatable-thead > tr > th {
  background: #f9fafb;
  color: #374151;
  font-weight: 600;
  padding: 0.75rem 1rem;
  border-bottom: 2px solid #e5e7eb;
}
.configuration-panel-container .email-list-table ::ng-deep .p-datatable .p-datatable-tbody > tr {
  transition: background-color 0.2s;
}
.configuration-panel-container .email-list-table ::ng-deep .p-datatable .p-datatable-tbody > tr:hover {
  background: #f9fafb;
}
.configuration-panel-container .email-list-table ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f3f4f6;
}
.configuration-panel-container .module-mapping-section,
.configuration-panel-container .email-management-section {
  min-height: 300px;
}
.configuration-panel-container .module-assignment-section .field {
  margin-bottom: 1rem;
}
.configuration-panel-container .outlook-section,
.configuration-panel-container .gmail-section {
  display: flex;
  align-items: center;
  justify-content: center;
}
.configuration-panel-container .connected-state {
  animation: slideIn 0.4s ease-out;
  width: 100%;
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.configuration-panel-container .whatsapp-form {
  max-width: 1000px;
}
.configuration-panel-container ::ng-deep .configuration-tabs .p-tabview-nav {
  background: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}
.configuration-panel-container ::ng-deep .configuration-tabs .p-tabview-nav .p-tabview-nav-link {
  padding: 1rem 1.5rem;
  font-weight: 500;
}
.configuration-panel-container ::ng-deep .configuration-tabs .p-tabview-nav .p-tabview-nav-link:hover {
  background: #e9ecef;
}
.configuration-panel-container ::ng-deep .configuration-tabs .p-tabview-nav .p-highlight .p-tabview-nav-link {
  color: #3b82f6;
  border-bottom-color: #3b82f6;
}
.configuration-panel-container ::ng-deep .configuration-tabs .p-tabview-panels {
  padding: 2rem 1rem;
}
.configuration-panel-container ::ng-deep .communication-tabs .p-tabview-nav,
.configuration-panel-container ::ng-deep .notification-tabs .p-tabview-nav {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 6px 6px 0 0;
}
.configuration-panel-container ::ng-deep .p-chip-primary {
  background: #3b82f6;
  color: white;
}
.configuration-panel-container ::ng-deep .p-chip-primary .p-chip-remove-icon {
  color: white;
}
.configuration-panel-container ::ng-deep .p-chip-primary .p-chip-remove-icon:hover {
  background: rgba(255, 255, 255, 0.2);
}
.configuration-panel-container ::ng-deep .p-inputgroup-addon {
  background: #e9ecef;
  color: #495057;
  font-weight: 500;
  border: 1px solid #ced4da;
}
.configuration-panel-container ::ng-deep .p-dropdown:focus,
.configuration-panel-container ::ng-deep .p-inputtext:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 0.2rem rgba(59, 130, 246, 0.25);
}
@media (max-width: 768px) {
  .configuration-panel-container {
    padding: 1rem;
  }
  .configuration-panel-container .card {
    padding: 1rem;
  }
  .configuration-panel-container ::ng-deep .configuration-tabs .p-tabview-panels {
    padding: 1rem 0.5rem;
  }
  .configuration-panel-container .flex {
    flex-direction: column;
  }
  .configuration-panel-container .flex .flex-grow-1 {
    width: 100%;
  }
  .configuration-panel-container .flex p-button {
    width: 100%;
  }
}
::ng-deep .custom-confirm-dialog.p-dialog {
  max-width: 60vw !important;
  width: 60vw !important;
  border-radius: 1rem !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
  overflow: visible !important;
}
::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-content {
  padding: 0 !important;
  background: transparent !important;
  overflow: visible !important;
  border-radius: 1rem !important;
}
::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-header {
  display: none !important;
}
::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-footer {
  display: none !important;
}
@keyframes bounce-in {
  0% {
    transform: scale(0) translateY(20px);
    opacity: 0;
  }
  50% {
    transform: scale(1.1) translateY(0);
  }
  100% {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}
::ng-deep .animate-bounce-in {
  animation: bounce-in 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
::ng-deep .communication-config-content {
  position: relative;
  min-height: 400px;
}
::ng-deep .backdrop-blur-sm {
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
}
::ng-deep .inset-0 {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
::ng-deep .z-50 {
  z-index: 50;
}
@media (max-width: 768px) {
  ::ng-deep .custom-confirm-dialog.p-dialog {
    max-width: 90vw !important;
    width: 90vw !important;
  }
  ::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-content .flex {
    padding: 1.5rem !important;
  }
  ::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-content .flex .absolute {
    width: 5rem !important;
    height: 5rem !important;
    top: -2.5rem !important;
  }
  ::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-content .flex .absolute i {
    font-size: 2.5rem !important;
  }
  ::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-content .flex .mt-16 {
    margin-top: 3rem !important;
  }
  ::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-content .flex .mt-16 h3 {
    font-size: 1.25rem !important;
  }
  ::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-content .flex .mt-16 p {
    font-size: 0.95rem !important;
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }
  ::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-content .flex .mt-16 .flex {
    flex-direction: column !important;
    width: 100% !important;
  }
  ::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-content .flex .mt-16 .flex button {
    width: 100% !important;
    padding: 0.75rem 1.5rem !important;
  }
}
/*# sourceMappingURL=configuration-panel.component.css.map */
